import { Component, Input } from '@angular/core';

@Component({
  selector: 'nejo-order-type-form',
  templateUrl: './order-type-form.component.html',
  styleUrls: ['./order-type-form.component.scss'],
})
export class OrderTypeFormComponent {
  @Input() public form: any = null;
  @Input() public section: string;
  @Input() public type: string;
  public kpiGrouping: Array<any> = [];
  public kpiGroupingLoading: boolean = false;
}
